$(document).ready(function(){
  var sliderGallery = $('.slider__gallery');
  var sliderGallerySettings = {
    arrows: true,
    dots: false,
    infinite: false,
    variableWidth: true,
    responsive: [{
      breakpoint: 767,
      settings: {
        arrows: false,
        variableWidth: false,
        slidesToShow: 1,
      }
    }]
  };
  sliderGallery.slick(sliderGallerySettings);
});